import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
// import { getFFSeaExportConsoleManifestList, getFFSeaExportConsoleManifestMBLAddList } from '../../../../../../../Redux/action/FreightForwarding/Console/FFSeaExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../../../HelperFunctions';
import AddFFSeaExpConsoleManifest from './AddFFSeaExpConsoleManifest';
import axios from 'axios';
import { adminMainUrl } from '../../../../../../../Config';
import OverlayLoader from '../../../../../../../Common/Loaders/OverlayLoader';
import { getFFSeaExportConsoleManifestList, getFFSeaExportConsoleManifestMBLAddList } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaExpAction';
import Tabbings from '../../../Tabs/Tabbings';


const ListFFSEConsoleManifest = ({ accessedModules, accessedPermission, title, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSeaExportConsoleManifestList(token, user_id, queryParams.get("page") ?? 1));
            dispatch(getFFSeaExportConsoleManifestMBLAddList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const refresh = () => {
        if (token && user_id) {
            dispatch(getFFSeaExportConsoleManifestList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }

    const {
        loadingFFSeaExpConsoleManifestList,
        FFSeaExpConsoleManifestList,
        FFSeaExpConsoleManifestListError,
        FFSeaExpConsoleManifestListCurrentPage,
        FFSeaExpConsoleManifestListTotalPage,
        FFSeaExpConsoleManifestListTotalData,

        loadingFFSeaExpUnusedConsoleManifestMBLAddList,
        FFSeaExpUnusedConsoleManifestMBLAddList,
        FFSeaExpUnusedConsoleManifestMBLAddListError,
    } = useSelector(state => state?.FFSeaExpReducer);

    const [addMBLListOptions, setAddMBLList] = useState([]);
    useEffect(() => {
        if (FFSeaExpUnusedConsoleManifestMBLAddList) {
            let arr = [];
            FFSeaExpUnusedConsoleManifestMBLAddList.map((val) => arr.push({ value: val.id, label: val.mbl_number }));
            setAddMBLList(arr);
        }
    }, [FFSeaExpUnusedConsoleManifestMBLAddList])


    useEffect(() => {
        if (loadingFFSeaExpConsoleManifestList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFSeaExpConsoleManifestList]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);

    const downloadManifest = (id, console_manifest_unique_id) => {
        if (!id) { toast.error("Console Manifest not found"); return; }
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/console-manifest/pdf-generation?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `FF_SE_CONSOLE_MANIFEST_${console_manifest_unique_id ? console_manifest_unique_id : id}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadAll = (id) => {
        if (!id) { toast.error("Console Manifest not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/all-pdf-generation?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `ALL_CONSOLE_MANIFEST.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    useEffect(() => {
        if (FFSeaExpConsoleManifestList) {
            let arr = [];
            FFSeaExpConsoleManifestList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    console_manifest_number: val.console_manifest_unique_id,
                    generated_date: val.generated_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.generated_date) : "",
                    mbl_number: val?.mbl_detail ? val?.mbl_detail?.mbl_number : "",
                    // hawb_numbers: val.mawb_id,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                {accessedPermission.includes("ff_se_console_manifest_download") && <button className="dropdown-item" onClick={() => { downloadManifest(val.id, val.console_manifest_unique_id) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download Console Manifest</>}
                                </button>}
                                {/* {accessedPermission.includes("ff_se_console_manifest_download") && <button className="dropdown-item" onClick={() => { downloadAll(val.id) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download Related MAWB & HAWBs</>}
                                </button>} */}

                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        }
    }, [FFSeaExpConsoleManifestList]);

    useEffect(() => {
        if (FFSeaExpConsoleManifestListCurrentPage) {
            setCurrentPage(FFSeaExpConsoleManifestListCurrentPage);
        }

        if (FFSeaExpConsoleManifestListTotalPage) {
            setTotalPages(FFSeaExpConsoleManifestListTotalPage)
        }
    }, [
        FFSeaExpConsoleManifestListCurrentPage,
        FFSeaExpConsoleManifestListTotalPage,
        FFSeaExpConsoleManifestListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    // adjust the add and update forms
    const [showAdd, setShowAdd] = useState(false);
    const handleAddClose = () => setShowAdd(false);
    const handleAddShow = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleEditClose = () => setShowEdit(false);
    const handleEditShow = () => setShowEdit(true);

    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Console Manifest No.", dataIndex: "console_manifest_number", key: "console_manifest_number" },
        { title: "Generated Date", dataIndex: "generated_date", key: "generated_date" },
        { title: "MBL No.", dataIndex: "mbl_number", key: "mbl_number" },
        // { title: "HAWB Numbers", dataIndex: "hawb_numbers", key: "hawb_numbers" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {title} <span className="count-title">{FFSeaExpConsoleManifestListTotalData ? FFSeaExpConsoleManifestListTotalData : "0"}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <Tabbings
                                console_manifest_url={console_manifest_url}
                                console_master_url={console_master_url}
                                console_house_url={console_house_url}
                                direct_master_url={direct_master_url}
                                job_order_url={job_order_url}
                                tab_imp_exp={tab_imp_exp}
                                tab_air_sea={tab_air_sea}
                                accessedPermission={accessedPermission}
                            />
                            <div className="card">
                                <div className="card-header">
                                    {accessedPermission.includes("ff_ae_console_manifest_add") && <div className="d-flex justify-content-end">
                                        {/* <Link to="/flexichain/job-order/freight-forwarding/shipment/air/export/console/manifest/add" className="btn btn-sm btn-primary">+Add Console Manifest</Link> */}
                                        <button className="btn btn-sm btn-primary" onClick={handleAddShow}>+Add Console Manifest</button>
                                    </div>}
                                </div>
                                <div className="card-body">
                                    {/* Contact List */}
                                    <div className="table-responsive custom-table">
                                        <Table className="table datanew dataTable no-footer"
                                            // rowSelection={rowSelection} 
                                            dataSource={dataSource}
                                            columns={columns}
                                            pagination={false} />
                                    </div>

                                    <div className="row align-items-center">
                                        {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                            <ReactPaginate
                                                previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                nextLabel={<img src="/img/left.png" alt="Next" />}
                                                breakLabel="..."
                                                breakClassName="break-me"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                forcePage={currentPage - 1}
                                            />
                                        </div> :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            <AddFFSeaExpConsoleManifest
                show={showAdd}
                handleClose={handleAddClose}
                loadingFFSeaExpUnusedConsoleManifestMBLAddList={loadingFFSeaExpUnusedConsoleManifestMBLAddList}
                addMBLListOptions={addMBLListOptions}
                token={token}
                user_id={user_id}
                refresh={refresh}
            />

            {
                disableDownloadPDF && <OverlayLoader />
            }

        </>

    )
}

export default ListFFSEConsoleManifest